import { Switch } from '@headlessui/react'
import { SpanSwitch, switchStyles } from './styles'
import { Control, Controller, FieldValues} from 'react-hook-form'

interface SwithToggleProps {
    enabled: boolean
    setEnabled: (b: boolean) => void,
    name?: string
    disabled?: boolean
    control?: Control<FieldValues, any>
    style?: any
}

export function SwitchToggle({ enabled, setEnabled, name, control, disabled = false, style }: SwithToggleProps) {
    if (control) {
        return <Controller
            disabled={disabled}
            defaultValue={enabled}
            control={control}
            name={name}
            render={({ field: { onChange, value } }) => {
                return <Switch
                    style={style}
                    disabled={disabled}
                    data-testid="switch"
                    checked={value}
                    onChange={(isChecked) => {
                        setEnabled(isChecked)
                    }}
                    className={`${enabled ? 'bg-yellow' : 'bg-gray-300'
                        } ${switchStyles}`}
                >
                    <span className="sr-only">Use setting</span>
                    <SpanSwitch
                        aria-hidden="true"
                        className={`${enabled ? 'translate-x-4' : 'translate-x-0'}
            `}
                    />
                </Switch>
            }}
        />
    }
    return <Switch
        disabled={disabled}
        data-testid="switch"
        checked={enabled}
        onChange={(value) => {
            setEnabled(value)
        }
        }
        className={`${enabled ? 'bg-yellow' : 'bg-gray-300'
            } ${switchStyles}`}
    >
        <span className="sr-only">Use setting</span>
        <SpanSwitch
            aria-hidden="true"
            className={`${enabled ? 'translate-x-4' : 'translate-x-0'}
            `}
        />
    </Switch>
}
